module.exports = __webpack_public_path__ + "img/main.9da1e778.jpg";